<template>
  <div
    v-if="isVisible"
    class="modal-backdrop fade show"
  ></div>

  <div
    class="modal fade"
    :class="{ show: isVisible }"
    :style="{ display: isVisible ? 'block' : 'none' }"
    tabindex="-1"
    :aria-hidden="!isVisible"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-info-subtle">
          <h5 class="modal-title">
            <span class="material-icons me-2" style="vertical-align: middle;">info</span>
            Tip: Split Into Multiple Routes
          </h5>
        </div>
        <div class="modal-body">
          <p>
            Your route is over 30 km. For a better experience, consider splitting it into
            separate days or routes using the <strong>Split Route</strong> feature.
          </p>
          <p class="text-muted mb-0">
            Multi-day hikes with shorter individual routes are easier to follow on the trail
            and provide more accurate elevation and timing data.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link text-muted" @click="dontShowAgain">Don't show again</button>
          <button type="button" class="btn btn-primary" @click="dismiss">Got it</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { dismissRouteLengthWarningPermanently } from '../services/routeLengthWarningPreference';

export default defineComponent({
  setup() {
    const isVisible = ref(false);

    function show() {
      isVisible.value = true;
    }

    function dismiss() {
      isVisible.value = false;
    }

    // Permanent, per-device opt-out: never show the warning again on this device.
    function dontShowAgain() {
      dismissRouteLengthWarningPermanently();
      isVisible.value = false;
    }

    return {
      isVisible,
      show,
      dismiss,
      dontShowAgain
    };
  }
});
</script>

<style scoped>
.bg-info-subtle {
  background-color: #fddf00 !important;

  h5, .modal-title, .material-icons {
    color: #212529 !important;
  }
}

.modal-header .material-icons {
  font-size: 24px;
}
</style>
